import { useState } from "react";
import { Button, DraggableCarousel } from "../../../components/ui";
import localization from "../../../config/localization";
import { ActiveBonus } from "./BonusStatus/ActiveBonus";
import { ConsumedBonus } from "./BonusStatus/ConsumedBonus";
import { CancelledBonus } from "./BonusStatus/CancelledBonus";
import { ExpiredBonus } from "./BonusStatus/ExpiredBonus";

export default function Bonus() {
  const [activeTabId, setActiveTab] = useState("active");

  const tabs = [
    {
      id: "active",
      label: localization.active_bonus_tab,
      component: <ActiveBonus />,
    },
    {
      id: "consumed",
      label: localization.consumed_bonus_tab,
      component: <ConsumedBonus />,
    },
    {
      id: "cancelled",
      label: localization.cancelled_bonus_tab,
      component: <CancelledBonus />,
    },
    {
      id: "expired",
      label: localization.expired_bonus_tab,
      component: <ExpiredBonus />,
    },
  ];

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const activeContent = tabs.find((tab) => tab.id === activeTabId)?.component;
  const activeIndex = tabs.findIndex((tab) => tab.id === activeTabId);

  return (
    <div className="w-full lg:max-w-[95%] lg:mx-auto pb-20 lg:pb-0">
      <div className="h-9 text-white">
        <div className="px-6 py-4">
          <DraggableCarousel gap="gap-10" activeIndex={activeIndex}>
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className="relative pb-2 text-sm md:text-base font-medium transition-colors duration-200"
              >
                <span
                  className={
                    activeTabId === tab.id ? "text-white" : "text-gray-400"
                  }
                >
                  {tab.label}
                </span>
                {activeTabId === tab.id && (
                  <span className="absolute left-[-12.5%] right-[-12.5%] bottom-0 h-0.5 bg-pink-300 rounded-full"></span>
                )}
              </Button>
            ))}
          </DraggableCarousel>
        </div>
      </div>

      {activeContent && (
        <div className="px-6 py-4 mt-3 text-white">{activeContent}</div>
      )}
    </div>
  );
}
